import React from 'react'
import formatPrice from '../../../utilities/currency/formatPrice'

const BkFlowRoomCardUpSellsCurrentRoom = props => {
  const {
    configData,
    displayedPriceFrequency,
    selectedRoomTypeName,
    selectedRoomTypeImage,
    selectedRoomRateName,
    selectedRoomRatePrice,
    selectedRoomRateCurrencySymbol,
    handleSkipEvent,
  } = props

  const hotelLabels = configData.hotel.labels[0]

  return (
    <div className="bk-flow-room__card-upsells-current">
      { selectedRoomTypeImage &&
        <div
          className="bk-flow-room__card-upsells-current-img u-bg-image"
          style={{ backgroundImage: 'url(' + selectedRoomTypeImage + ')' }}
        >
          <img
            className="u-element-hidden"
            src={ selectedRoomTypeImage }
            alt="Selected Room Type"
          />
        </div>
      }

      <div className="bk-flow-room__card-upsells-current-body">
        <p className="title">
          { hotelLabels && hotelLabels.currentSelectedRoom ? hotelLabels.currentSelectedRoom : 'Currently Selected Room' }
        </p>

        { selectedRoomTypeName && <p className="u-remove-margin name">{ selectedRoomTypeName }</p> }
        { selectedRoomRateName && <p className="u-remove-margin rate">{ selectedRoomRateName }</p> }
        { selectedRoomRatePrice &&
          <p className="u-font-bold price">
            { selectedRoomRateCurrencySymbol && selectedRoomRateCurrencySymbol }
            { formatPrice(selectedRoomRatePrice, 2) }/
            { displayedPriceFrequency === 'per stay' ? (
              hotelLabels && hotelLabels.total ? hotelLabels.total : 'Total'
            ) : (
              hotelLabels && hotelLabels.night ? hotelLabels.night : 'Night'
            )}
          </p>
        }

        <button
          className="btn btn-text-only"
          onClick={ handleSkipEvent }
        >
          { selectedRoomTypeName ?
            'Continue with ' + selectedRoomTypeName
          :
            hotelLabels.continue
          }
        </button>
      </div>
    </div>
  )
}

export default BkFlowRoomCardUpSellsCurrentRoom



// WEBPACK FOOTER //
// ./src/components/room/upsells/BkFlowRoomCardUpSellsCurrentRoom.js